import type { ComponentProps } from 'react';
import { Link } from '../../../Link/Link';

type ViewAllLinkProps = ComponentProps<typeof Link>;

/**
 * A component that renders a view all link. Used in the FaqSection component.
 * @param children - The text of the view all link.
 * @param href - The href of the view all link.
 * @param props - The props of the view all link.
 * @returns The view all link component.
 */
function ViewAllLink({ children, href, ...props }: ViewAllLinkProps) {
  return (
    <Link {...props} href={href!} simplified hasArrow data-track-name="View All">
      {children}
    </Link>
  );
}

export { ViewAllLink };
